import React, { FC, ReactElement } from 'react'
import classNames from 'classnames'
import { Card, Container } from '@scentregroup/ui'
import {
  CustomThemeContext,
  ThemeOption,
  BasicPageContext,
  useEvolvedContext,
} from '../../context'
import Article from '../article'
import InfoAccordion from '../info-accordion'
import style from '../feature/index.module.scss'
import { Centre, RawOpeningHours } from '../../../types/contentful-v1'
import { ParkingModule } from '../../../types/contentful'
import ServiceUtilityBox from '../service-utility-box'
import accordionEntriesFromModules from './accordion-entries-from-modules'

interface ParkingModulesProps {
  centre: Centre
  centreTradingHours: RawOpeningHours
  modules: ParkingModule[]
}

const ParkingModules: FC<ParkingModulesProps> = ({
  centre,
  modules,
  centreTradingHours,
}: ParkingModulesProps): ReactElement => {
  const isEvolved = useEvolvedContext()

  return (
    <CustomThemeContext.Consumer>
      {(themeOption: ThemeOption) => (
        <BasicPageContext.Consumer>
          {isBasicPage => (
            <div
              className={classNames(
                style.Feature,
                style.ParkingFeature,
                style.placeholder,
                {
                  [style.placeholderNotEvolved]: !isEvolved,
                  [style.Grey]: themeOption.luxury,
                  [style.evolved]: isEvolved,
                }
              )}
            >
              <Container
                centred
                type="large"
                className={classNames(style.Container)}
              >
                <Card className={style.Card}>
                  <Article
                    superheading={isBasicPage ? '' : 'Service'}
                    heading={isBasicPage ? '' : 'Parking'}
                    headingType="large"
                  >
                    <InfoAccordion
                      metaRows={accordionEntriesFromModules(modules, centre)}
                      purpose="Parking information"
                      theme="parking"
                    />
                  </Article>
                </Card>
                <div className={style.Sidebar}>
                  <ServiceUtilityBox
                    centre={centre}
                    centreTradingHours={centreTradingHours}
                  />
                </div>
              </Container>
            </div>
          )}
        </BasicPageContext.Consumer>
      )}
    </CustomThemeContext.Consumer>
  )
}

export default ParkingModules
